
import React from "react";
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  icon: LucideIcon;
  size?: number;
  className?: string;
  strokeWidth?: number;
}

/**
 * A consistent wrapper for all icons in the application
 * This ensures icons render at the exact size specified
 */
export const Icon = ({ 
  icon: LucideIcon, 
  size = 24, 
  className, 
  strokeWidth = 2, 
  ...props 
}: IconProps) => {
  // Calculate actual dimensions to ensure consistent rendering
  const dimensions = {
    width: size,
    height: size,
    // Force minimum dimensions to prevent icon from being sized down
    style: { 
      minWidth: `${size}px`, 
      minHeight: `${size}px` 
    }
  };
  
  return (
    <LucideIcon
      className={cn(className)}
      size={size}
      strokeWidth={strokeWidth}
      {...dimensions}
      {...props}
    />
  );
};

export default Icon;
